import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import CharacterSheetExpansionFeatures from '@/pages/Tools/MyCharacters/CharacterSheet/CharacterSheetExpansionFeatures.vue';
import CharacterSheetCastingAddPower from '@/pages/Tools/MyCharacters/CharacterSheet/CharacterSheetCastingAddPower.vue';
import { namespace } from 'vuex-class';
const powersModule = namespace('powers');
let CharacterBuilderClassPowers = class CharacterBuilderClassPowers extends Vue {
    created() {
        this.fetchPowers();
    }
    get powersSelected() {
        const classPowers = this.myClass[this.castingType.toLowerCase() + 'Powers'] || [];
        const archetypePowers = (this.isArchetypeCasting && this.myClass.archetype[this.castingType.toLowerCase() + 'Powers']) || [];
        return [...classPowers, ...archetypePowers];
    }
    get powersSelectedData() {
        return this.powers.filter(({ level, powerType, name }) => this.powersSelected.includes(name));
    }
    get isArchetypeCasting() {
        return this.archetypeData && this.archetypeData.casterType !== 'None' && this.archetypeData.casterRatio > 0;
    }
    get castingType() {
        return this.isArchetypeCasting ? this.archetypeData.casterType : this.classData.casterType;
    }
    get numberPowersKnown() {
        return this.getLevelTableField(this.castingType + ' Powers Known');
    }
    get maxPowerLevel() {
        return this.getLevelTableField('Max Power Level');
    }
    getLevelTableField(field) {
        const classField = parseInt(this.classData.levelChanges[this.myClass.levels][field]);
        let archetypeField = 0;
        if (this.isArchetypeCasting) {
            const leveledTable = this.archetypeData.leveledTable;
            if (leveledTable) {
                const powersKnownKeyValue = leveledTable[this.myClass.levels].find(({ key }) => key === field);
                archetypeField = powersKnownKeyValue ? parseInt(powersKnownKeyValue.value) : 0;
            }
        }
        archetypeField = isNaN(archetypeField) ? 0 : archetypeField;
        return isNaN(classField) ? archetypeField : classField;
    }
    handleUpdatePowers(newPowers) {
        this.$emit('updatePowers', { newPowers, type: this.castingType, isArchetype: this.isArchetypeCasting });
    }
};
__decorate([
    Prop(Object)
], CharacterBuilderClassPowers.prototype, "myClass", void 0);
__decorate([
    Prop(Object)
], CharacterBuilderClassPowers.prototype, "classData", void 0);
__decorate([
    Prop(Object)
], CharacterBuilderClassPowers.prototype, "archetypeData", void 0);
__decorate([
    Prop(Object)
], CharacterBuilderClassPowers.prototype, "settings", void 0);
__decorate([
    Prop(Array)
], CharacterBuilderClassPowers.prototype, "allForcePowers", void 0);
__decorate([
    powersModule.State
], CharacterBuilderClassPowers.prototype, "powers", void 0);
__decorate([
    powersModule.Action
], CharacterBuilderClassPowers.prototype, "fetchPowers", void 0);
CharacterBuilderClassPowers = __decorate([
    Component({
        components: {
            CharacterSheetExpansionFeatures,
            CharacterSheetCastingAddPower
        }
    })
], CharacterBuilderClassPowers);
export default CharacterBuilderClassPowers;
